var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 31,
    viewBox: "0 0 82 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.832,
    y: 0.197,
    width: 80.337,
    height: 30.103,
    rx: 4.661,
    fill: "#fff",
    stroke: "#090909",
    strokeWidth: 0.337
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#21hqujfuma)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.984 7.903c-.173.183-.275.468-.275.836v13.166c0 .37.102.653.275.837l.043.043 7.347-7.376v-.174L9.027 7.86l-.043.044z",
    fill: "url(#t0je82lysb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.822 17.867-2.449-2.46v-.173l2.45-2.459.054.032 2.902 1.655c.828.473.828 1.246 0 1.72l-2.902 1.654-.055.031z",
    fill: "url(#fw011piajc)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#6xoqhjfgqd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.877 17.837-2.505-2.515-7.39 7.42c.273.29.724.326 1.233.037l8.662-4.942z",
    fill: "url(#xl76uwtu0e)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18.877 12.807-8.662-4.94c-.509-.29-.96-.255-1.233.036l7.391 7.42 2.504-2.516z",
    fill: "url(#de2myl3xhf)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.034 13.22c-1.317 0-2.39 1-2.39 2.38 0 1.37 1.073 2.38 2.39 2.38 1.318 0 2.392-1.01 2.392-2.38-.001-1.38-1.075-2.38-2.392-2.38zm0 3.824c-.722 0-1.344-.595-1.344-1.443 0-.858.623-1.444 1.344-1.444.722 0 1.344.586 1.344 1.444 0 .847-.622 1.443-1.344 1.443zm-5.216-3.825c-1.318 0-2.391 1.002-2.391 2.381 0 1.37 1.073 2.38 2.39 2.38 1.318 0 2.392-1.01 2.392-2.38 0-1.38-1.074-2.38-2.392-2.38zm0 3.825c-.722 0-1.345-.595-1.345-1.443 0-.858.623-1.444 1.345-1.444.721 0 1.344.586 1.344 1.444 0 .847-.623 1.443-1.344 1.443zm-6.205-3.094v1.01h2.418c-.072.568-.261.983-.55 1.271-.352.352-.902.74-1.868.74-1.489 0-2.652-1.2-2.652-2.688 0-1.488 1.163-2.687 2.652-2.687.803 0 1.39.316 1.823.721l.712-.712c-.604-.577-1.407-1.02-2.535-1.02-2.04 0-3.754 1.66-3.754 3.698 0 2.039 1.715 3.698 3.754 3.698 1.1 0 1.931-.361 2.58-1.038.668-.667.876-1.605.876-2.362 0-.234-.018-.451-.055-.631h-3.401zm25.376.785c-.198-.532-.803-1.516-2.04-1.516-1.227 0-2.246.965-2.246 2.381 0 1.335 1.01 2.38 2.364 2.38a2.371 2.371 0 0 0 1.985-1.054l-.812-.542c-.27.397-.64.659-1.173.659-.532 0-.911-.244-1.155-.722l3.185-1.317-.108-.27zm-3.248.793c-.027-.92.712-1.389 1.245-1.389.415 0 .767.208.884.505l-2.13.884zm-2.59 2.309h1.046v-6.998h-1.046v6.998zm-1.715-4.085H47.4c-.234-.28-.686-.533-1.254-.533-1.19 0-2.282 1.046-2.282 2.39 0 1.335 1.091 2.372 2.282 2.372.569 0 1.02-.252 1.254-.54h.036v.342c0 .911-.487 1.398-1.272 1.398-.64 0-1.038-.46-1.2-.848l-.911.38c.261.63.956 1.406 2.111 1.406 1.227 0 2.265-.721 2.265-2.48v-4.275h-.992v.388zm-1.2 3.292c-.721 0-1.326-.605-1.326-1.434 0-.84.605-1.453 1.327-1.453.712 0 1.271.613 1.271 1.453 0 .83-.559 1.434-1.271 1.434zm13.656-6.205h-2.504v6.998h1.044v-2.651h1.46c1.157 0 2.297-.838 2.297-2.173s-1.139-2.174-2.297-2.174zm.027 3.373h-1.487v-2.399h1.487c.781 0 1.225.647 1.225 1.2 0 .542-.444 1.199-1.225 1.199zm6.459-1.005c-.757 0-1.54.333-1.865 1.071l.927.387c.199-.387.568-.513.955-.513.54 0 1.09.324 1.1.9v.072a2.314 2.314 0 0 0-1.09-.27c-1 0-2.019.55-2.019 1.576 0 .936.82 1.539 1.739 1.539.702 0 1.09-.315 1.333-.685h.036v.54h1.009v-2.683c0-1.241-.928-1.934-2.126-1.934zm-.127 3.835c-.342 0-.82-.171-.82-.595 0-.54.595-.747 1.109-.747.459 0 .675.1.954.234a1.267 1.267 0 0 1-1.243 1.108zm5.927-3.682-1.198 3.034h-.036l-1.243-3.034h-1.126l1.865 4.24-1.063 2.36h1.09l2.873-6.6h-1.162zm-9.412 4.477h1.044v-6.998h-1.044v6.998z",
    fill: "#090909"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "t0je82lysb",
    x1: 15.723,
    y1: 8.6,
    x2: 5.732,
    y2: 18.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fw011piajc",
    x1: 22.857,
    y1: 15.321,
    x2: 8.509,
    y2: 15.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xl76uwtu0e",
    x1: 17.517,
    y1: 16.688,
    x2: 3.969,
    y2: 30.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de2myl3xhf",
    x1: 7.121,
    y1: 3.52,
    x2: 13.171,
    y2: 9.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "21hqujfuma",
    x: 8.709,
    y: 7.666,
    width: 13.691,
    height: 15.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1175_3329"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_1175_3329",
    result: "effect2_innerShadow_1175_3329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "6xoqhjfgqd",
    x: 8.982,
    y: 15.322,
    width: 9.895,
    height: 7.656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.089
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1175_3329"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreSmall);
export default __webpack_public_path__ + "static/media/playStoreSmall.e6c933c625b19294cb02c8c53c2f8608.svg";
export { ForwardRef as ReactComponent };